import axios from "axios";
import { message } from "antd";

import store from "../store";

/*
 * Validation endpoints return Cerberus errors as {field: ["problem", ...]}
 * instead of a string; flatten them into "field: problem" so the toast
 * does not read "[object Object]".
 */
function formatServerMessage(msg) {
  if (typeof msg === "string") return msg;
  if (!msg || typeof msg !== "object") return null;

  return Object.entries(msg)
    .map(([field, problems]) => {
      const text = []
        .concat(problems)
        .map((p) => (typeof p === "string" ? p : JSON.stringify(p)))
        .join(", ");
      return `${field}: ${text}`;
    })
    .join("; ");
}

function getErrorMessage(err, description) {
  if (axios.isCancel(err)) return null;

  const status = err?.response?.status;
  const text =
    formatServerMessage(err?.response?.data?.message) ||
    description ||
    "Something went wrong.";

  return status ? `${status}: ${text}` : text;
}

export function showError(err, description, display) {
  const msg = getErrorMessage(err, description);

  if (!msg) return;

  // Prefer the contextual App-level message (stored in redux by withApp) so
  // toasts pick up theme/context, fall back to the static antd instance
  const show =
    display || store.getState().antd?.message?.error || message.error;

  show(msg);
}
